<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="tab-info-card">
        <div class="user-detail">
          <div class="tab-info-title">订单基本信息</div>
          <div class="tab-info-content tab-base">
            <div class="tab-base-item">
              <span class="tab-base-label">订单编号：</span>
              <span class="tab-base-value">{{detailFormData.orderNumber}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">订单状态：</span>
              <span class="tab-base-value">
                <span style="color: #409eff;" v-if="detailFormData.state*1 === 1">未兑换</span>
                <span style="color: #f56c6c;" v-if="detailFormData.state*1 === 2">已兑换未评价</span>
                <span style="color: #67c23a;" v-if="detailFormData.state*1 === 3">已评价</span>
                <span style="color: #909399;" v-if="detailFormData.state*1 === 4">已取消</span>
              </span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">下单时间：</span>
              <span class="tab-base-value">{{detailFormData.createTime}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">兑换时间：</span>
              <span class="tab-base-value">{{detailFormData.exchangeTime}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">兑换用户：</span>
              <span class="tab-base-value">{{detailFormData.nickName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">兑换社区：</span>
              <span class="tab-base-value">{{detailFormData.siteName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">兑换方式：</span>
              <span class="tab-base-value" v-if="detailFormData.orderType*1 === 1">自提</span>
              <span class="tab-base-value" v-if="detailFormData.orderType*1 === 2">售货柜</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">兑换账号：</span>
              <span class="tab-base-value">{{detailFormData.phone}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">工作人员：</span>
              <span class="tab-base-value">{{detailFormData.employeesName}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">售货柜订单：</span>
              <span class="tab-base-value">{{detailFormData.onlineOrderId}}</span>
            </div>
            <div class="tab-base-item">
              <span class="tab-base-label">售货柜：</span>
              <span class="tab-base-value">{{detailFormData.onlineMachine}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- tab内容 -->
      <div class="tab-info-card tab-info-padding">
        <div class="tab-info-title">
          <span>商品信息</span>
          <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_ORDER:EXPORT'" v-bind:key="index">
            <el-button size="small" @click="importExcel">导出Excel</el-button>
          </wt-auth>
        </div>
        <el-table :data="detailFormData.orderGoodsList" style="width: 100%">
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="goodsNo" label="商品编号"></el-table-column>
          <el-table-column label="商品图片">
            <template slot-scope="data">
              <img class="table-img" v-if="data.row.goodsCover && data.row.goodsCover.length > 0" :src="imgUrl + data.row.goodsCover.split(',')[0]">
            </template>
          </el-table-column>
          <el-table-column prop="goodsTitle" label="商品标题"></el-table-column>
          <el-table-column prop="singleIntegral" label="积分"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
          <el-table-column prop="evaluation" label="评价">
            <template slot-scope="data">
              <div v-html="data.row.evaluation"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Order-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERMESSAGE',
      isSubmitLoading: false,
      detailFormButtons: {
        title: '订单详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      }
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    secondBtnsEvents() {

    },
    onButtonAction() {

    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    },
    importExcel() {
      const _timer = (new Date()).getTime()
      const _fileName = '订单商品导出' + _timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: '/modules/order/orderGoodsListImport',
        data: { id: this.detailFormData.id },
        fileName: _fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        this.$message({ message: err, type: 'error' })
      })
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.order.orderDetailData
    })
  }
}
</script>

<style lang="scss" scoped>
.user-info-card {
  .user-detail {
    background: #fff;
    .user-detail-top {
      display: flex;
      align-items: center;
      padding: 20px;
    }
    .user-detail-photo {
      width: 48px;
      height: 48px;
      border: 1px solid #666;
      border-radius: 50%;
      margin-right: 16px;
    }
    .user-detail-username {
      font-size: 20px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
      margin-right: 16px;
    }
    .user-detail-level {
      padding: 2px 8px;
      font-size: 12px;
      line-height: 14px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #666;
    }
    .user-detail-bottom {
      display: flex;
      align-items: center;

    }
    .user-detail-label {
      margin-left: 84px;
      color: #989898;
    }
    .user-detail-value {
      color: #666666;
    }
  }
}
.tab-info-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid rgba(228, 228, 228, 1);
  font-size: 16px;
  font-weight: 600;
  color: #444;
}
.tab-info-card {
  margin-top: 20px;
  background: #fff;

  .tab-base {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .tab-base-item {
      display: flex;
      align-items: center;
      width: 400px;
      margin-bottom: 20px;
    }
    .tab-base-label {
      width: 100px;
      text-align: right;
      color: #989898;
    }
    .tab-base-value {
      color: #666666;
    }
  }
  .tab-info-content {
    padding: 20px;
  }
}
.tab-info-padding {
  padding: 20px;
}
</style>
<style lang="scss">
.user-info-card {
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__item.is-active {
      color: #108ee9;
    }
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
  .el-tabs {
    margin-top: 20px;
  }
}
</style>
